import PATH from "constants/path";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getNew } from "features/News/newSlice";
import { SERVICE } from "constants/global";
import { isAuthenticated } from "utils/common";
import ErrorDB from "components/ErrorDB";

function New() {
  const dispatch = useDispatch();

  const { id } = useParams();
  const { new: detail, isInLine } = useSelector((state) => state.news);

  useEffect(() => {
    if (id) {
      dispatch(getNew({ service: SERVICE, id }));
    }
  }, []);

  if (detail === null) return null;

  return (
    <div
      className={isAuthenticated() ? "w-80" : "container px-0 px-md-3 px-lg-0"}
    >
      <div className="border-sticky border-news-no-top bg-f4 p-2 text-grey">
        <div className="position-relative text-center fs-14 fw-600">
          ニュース
          <a
            href={PATH.NEWS}
            className="d-flex position-absolute start-0 top-0"
          >
            <i className="bi bi-chevron-left"></i>
            <span className="d-none d-md-block">戻る</span>
          </a>
        </div>
      </div>
      {
        isInLine ?
        <ErrorDB style={'mt-4'}/>
        :
        <div className="mt-3 px-3 px-md-0">
          <div className="my-0 my-md-3">
            <div className="fs-14 fs-sm-12 fs-400">
              {detail?.posted} ({detail?.day_of_week})
            </div>
            <div className="fs-18 fs-ms-16 fw-600 text-start">
              {detail?.title}
            </div>
          </div>

          <hr className="d-block d-md-none" />

          <div
            className="html-design-table border-color-black border-form-hidden border-radius-5 my-1 py-0 py-md-3 px-0 px-md-3"
            dangerouslySetInnerHTML={{ __html: detail?.body }}
          ></div>
        </div>
      }
    </div>
  );
}

export default New;
